<template>
  <div style="margin-top: 50px">
    <mt-header title="系统参数设置">
      <router-link to="/My" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
      <div slot="right">
        <mt-button class="m-1" @click="formSubmit"><img slot="icon" src="@/assets/success.png" width="24" height="24" />
        </mt-button>
      </div>
    </mt-header>
    <scroll-body class="m-2" :minheight="100" :outheight="160" :isScroll="true" @resize="resize">
      <template slot="content">
        <el-divider content-position="left">
          <font color="red">网站信息</font>
        </el-divider>
        <mt-field label="单位全称" placeholder="请输入单位全称" v-model="parameters.maintenanceUnitName" />
        <mt-field label="单位简称" placeholder="请输入单位简称" v-model="parameters.maintenanceUnitMiniName" />
        <mt-field label="系统全称" placeholder="请输入系统全称" v-model="parameters.systemName" />
        <mt-field label="系统简称" placeholder="请输入系统简称" v-model="parameters.systemMiniName" />
        <el-divider content-position="left">
          <font color="red">网站联系人</font>
        </el-divider>
        <mt-field label="姓名" placeholder="请输入联系人姓名" v-model="parameters.userName" />
        <mt-field label="手机" placeholder="请输入联系人手机" v-model="parameters.phone" />
        <mt-field label="邮箱" placeholder="请输入联系人邮箱" v-model="parameters.email" />
        <el-divider content-position="left">
          <font color="red">工单办理期限</font>
        </el-divider>
        <mt-field label="期限值" placeholder="请输入期限值(小时数)" v-model="parameters.transferHours" />
        <el-divider content-position="left">
          <font color="red">工单领域设置</font>
        </el-divider>
        <el-tag :key="tag" v-for="tag in parameters.domains" closable :disable-transitions="false"
          @close="handleClose(tag)">
          {{ tag }}
        </el-tag>
        <el-input class="input-new-tag" v-if="domain.inputVisible" v-model="domain.inputValue" ref="saveTagInput"
          size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm" />
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加领域</el-button>
      </template>
    </scroll-body>
  </div>
</template>

<script>
import ScrollBody from "@/components/ScrollBody.vue";
export default {
  name: "Parameters",
  components: {
    ScrollBody,
  },
  created() {
    //读取系统参数
    this.getWebsiteParameter();
  },
  data() {
    return {
      bodyStyle: {
        overflowY: "auto",
        overflowX: "hidden",
        listStyle: "none",
        height: 420 + "px",
      },
      //领域
      domain: {
        //tags: [],
        inputVisible: false,
        inputValue: "",
      },

      //网站参数
      parameters: {
        systemName: "",
        systemMiniName: "",
        maintenanceUnitName: "",
        maintenanceUnitMiniName: "",
        userName: "",
        phone: "",
        email: "",
        transferHours: 0,
        domains: "",
      },
    };
  },
  //方法对象
  methods: {
    resize(height) {
      this.bodyStyle.height = height - 10 + "px";
    },
    getWebsiteParameter() {
      //console.log('get website')
      this.appApi
        .getWebsiteAllParameters()
        .then((resp) => {
          //读取成功
          var data = resp.data;
          //console.log(data)
          this.parameters.systemName = data.systemName;
          this.parameters.systemMiniName = data.systemMiniName;
          this.parameters.maintenanceUnitName = data.maintenanceUnitName;
          this.parameters.maintenanceUnitMiniName =
            data.maintenanceUnitMiniName;
          this.parameters.transferHours = data.transferHours;
          this.parameters.domains = data.domains;
          this.parameters.userName = data.userName;
          this.parameters.phone = data.phone;
          this.parameters.email = data.email;
        })
        .catch((error) => {
          var message = error.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }
          this.$toast(message);
        });
    },
    //表单提交
    formSubmit(formName) {
      //校验通过
      var systemName = this.parameters.systemName;
      var systemMiniName = this.parameters.systemMiniName;
      var maintenanceUnitName = this.parameters.maintenanceUnitName;
      var maintenanceUnitMiniName = this.parameters.maintenanceUnitMiniName;
      var transferHours = parseInt(this.parameters.transferHours);
      let domains = this.parameters.domains;
      let userName = this.parameters.userName;
      let phone = this.parameters.phone;
      let email = this.parameters.email;

      //向服务器put数据
      this.appApi
        .updateWebiteParameters(
          systemName,
          systemMiniName,
          maintenanceUnitName,
          maintenanceUnitMiniName,
          transferHours,
          domains,
          userName,
          phone,
          email
        )
        .then(() => {
          //修改成功
          this.$toast("修改成功");
          this.pstApi.setWebsiteParameters(this.parameters);
        })
        .catch((err) => {
          var message = err.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }
          this.$toast(message);
        });
    },
    handleClose(tag) {
      this.parameters.domains.splice(this.parameters.domains.indexOf(tag), 1);
    },

    showInput() {
      this.domain.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.domain.inputValue;
      if (inputValue) {
        //this.$toast(inputValue);
        this.parameters.domains.push(inputValue);
      }
      //console.log(this.SystemParameters.domains)
      this.domain.inputVisible = false;
      this.domain.inputValue = "";
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.mint-cell {
  min-height: 32px;
}

/deep/ .mint-cell-wrapper {
  font-size: 14px;
}

/deep/ .mint-field .mint-cell-title {
  width: 60px;
}

/deep/input:disabled {
  background-color: #fff;
}

/deep/textarea:disabled {
  background-color: #fff;
}

/deep/textarea.mint-field-core {
  font-size: 14px;
}

//
.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>